// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1SwNB","assignButton":"CreateEditEquipmentSchedule_assignButton__3X4C7"};